const iframeFullscreen = {
    init() {
        console.log('[iframeFullscreen] init() aufgerufen');

        const triggers = document.querySelectorAll('.js-iframe-fullscreen');
        console.log('[iframeFullscreen] Gefundene Trigger im DOM:', triggers.length, triggers);

        const blocks = document.querySelectorAll('.iframe-block');
        console.log('[iframeFullscreen] Gefundene .iframe-block Elemente:', blocks.length, blocks);

        document.addEventListener('click', (event) => {
            const trigger = event.target.closest('.js-iframe-fullscreen');
            if (!trigger) return;

            console.log('[iframeFullscreen] Click auf Trigger:', trigger);

            event.preventDefault();
            event.stopPropagation();

            const block = trigger.closest('.iframe-block');
            console.log('[iframeFullscreen] Closest .iframe-block:', block);

            if (!block) {
                console.warn('[iframeFullscreen] Kein .iframe-block Parent gefunden!');
                return;
            }

            this.toggle(block);
        });

        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
                this.exitAll();
            }
        });

        console.log('[iframeFullscreen] Event-Listener registriert');
    },

    toggle(block) {
        const willBeFullscreen = !block.classList.contains('is-fullscreen');
        console.log('[iframeFullscreen] toggle() — wird fullscreen:', willBeFullscreen);

        block.classList.toggle('is-fullscreen');
        document.body.classList.toggle('has-fullscreen-iframe', this.hasOpenBlock());
        window.dispatchEvent(new Event('resize'));

        console.log('[iframeFullscreen] block classList nach toggle:', block.className);
    },

    exitAll() {
        const open = document.querySelectorAll('.iframe-block.is-fullscreen');
        if (!open.length) return;
        console.log('[iframeFullscreen] exitAll() — schließe', open.length, 'Block(s)');
        open.forEach((block) => block.classList.remove('is-fullscreen'));
        document.body.classList.remove('has-fullscreen-iframe');
        window.dispatchEvent(new Event('resize'));
    },

    hasOpenBlock() {
        return document.querySelectorAll('.iframe-block.is-fullscreen').length > 0;
    },
};

export default iframeFullscreen;
